import { Component } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/logo_header.png';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import './Header.scss';
import Login from 'components/Modals/Login/Login';
import User from 'services/store/User';
import Search from 'components/Search/Search';
import TutorialButton from 'components/Tutorial/TutorialButton';
import { clearLocalStorageExceptTutorial } from '../../utils/tutorialStorage';

class Header extends Component {
  constructor(props){ 
    super(props) 
    this.state = {
      openModal: false,
      menuAnchorEl: null,
    }
  } 

  onClickConnect = e =>{
    e.preventDefault()
    this.setState({ openModal: true })
  }

  setOpenModal = (value) => {
    this.setState({ openModal: value })
  }

  openUserMenu = (event) => {
    this.setState({ menuAnchorEl: event.currentTarget });
  }

  closeUserMenu = () => {
    this.setState({ menuAnchorEl: null });
  }

  handleMenuNavigation = () => {
    this.closeUserMenu();
  }

  logout = (event) => {
    if (event) {
      event.preventDefault();
    }

    this.closeUserMenu();
    this.props.setToken(null);
    
    // Vider le localStorage en préservant les données du tutoriel
    clearLocalStorageExceptTutorial();
    
    // Vider le sessionStorage
    sessionStorage.clear();
    
    User.logoutUser();
    window.location.reload();
  }
  
  toggleMenu = () => {
    const menu = document.getElementById('menu');

    if (menu.style.display === 'block') {
      document.getElementById('menu').style.display = 'none';
    } else {
      document.getElementById('menu').style.display = 'block';
    }
  }

  headerClass = () => {
    return this.props.token ? "header mod-noMargin" : "header";
  }

  userEmail = () => {
    const user = User.getUser();
    return user["contact"] ? user["contact"]["email"] : "email";
  }

  userInitial = () => {
    const email = this.userEmail();
    return email ? email.charAt(0).toUpperCase() : 'U';
  }

  isCurrentPath = (path) => {
    return window.location.pathname === path;
  }
  //                <li><button onClick={this.onClickConnect}>Se Connecter</button></li>

  render() {
    const isUserMenuOpen = Boolean(this.state.menuAnchorEl);

    // Mode minimal : affiche uniquement le logo
    if (this.props.minimal) {
      return (
        <header className="header">
          <div className="header-desktop">
            <ul className="header-left">
              <li><NavLink to="/"><img alt="logo dia fleur" className="header-logo" src={logo} /></NavLink></li>
            </ul>
          </div>
          <nav className="mobile-bottom-nav">
            <NavLink to="/" className="nav-logo">
              <img src={logo} alt="logo dia fleur" />
            </NavLink>
          </nav>
        </header>
      );
    }

    return (
      <header className={this.headerClass()}>
        <div className="header-mobile">
          <Search token={this.props.token} />
        </div>

        <div className="header-desktop">
            {this.props.token ? (
              <>
                <ul className="header-left">
                  <li><NavLink to="/"><img alt="logo dia fleur" className="header-logo" src={logo} /></NavLink></li>
                </ul>
                <Search token={this.props.token} />
              </>
            ) : (
              <ul className="header-left">
                <li><NavLink to="/"><img alt="logo dia fleur" className="header-logo" src={logo} /></NavLink></li>
                <li><NavLink to="/">Accueil</NavLink></li>
                <li><Button style={{textTransform: 'none', fontSize: '16px'}} variant="text" onClick={this.onClickConnect}>Se Connecter</Button></li>
              </ul>
            )}  
          <div>
            {this.props.token ? (
              <div className="dropdown header-right">
                <Button
                  type="button"
                  className="header-account-trigger"
                  variant="text"
                  onClick={this.openUserMenu}
                  aria-expanded={isUserMenuOpen ? 'true' : 'false'}
                  aria-controls={isUserMenuOpen ? 'header-account-menu' : undefined}
                  endIcon={<KeyboardArrowDownIcon />}
                  sx={{ textTransform: 'none' }}
                >
                  <Avatar className="header-account-avatar" sx={{ width: 34, height: 34 }}>
                    {this.userInitial()}
                  </Avatar>
                  <span className="header-account-email">{this.userEmail()}</span>
                </Button>
                <Menu
                  id="header-account-menu"
                  anchorEl={this.state.menuAnchorEl}
                  open={isUserMenuOpen}
                  onClose={this.closeUserMenu}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  PaperProps={{
                    className: 'dropdown-menu mui-account-menu',
                    sx: {
                      mt: 1,
                      minWidth: 280,
                      borderRadius: 3,
                      overflow: 'visible',
                      boxShadow: (theme) => theme.shadows[8],
                      border: (theme) => `1px solid ${theme.palette.divider}`,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: -8,
                        right: 18,
                        width: 16,
                        height: 16,
                        backgroundColor: 'background.paper',
                        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                        borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
                        transform: 'rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  }}
                  MenuListProps={{ className: 'header-account-menu-list' }}
                >
                  <div className="header-account-summary">
                    <Avatar className="header-account-avatar header-account-avatar-large" sx={{ width: 42, height: 42 }}>
                      {this.userInitial()}
                    </Avatar>
                    <div className="header-account-summaryContent">
                      <strong>Mon espace</strong>
                      <span>{this.userEmail()}</span>
                    </div>
                  </div>

                  <MenuItem
                    className="dropdown-item"
                    component={NavLink}
                    to="/products"
                    selected={this.isCurrentPath('/products')}
                    onClick={this.handleMenuNavigation}
                  >
                    <ListItemIcon>
                      <Inventory2OutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Produits" />
                  </MenuItem>
                  <MenuItem
                    className="dropdown-item"
                    component={NavLink}
                    to="/my-account"
                    selected={this.isCurrentPath('/my-account')}
                    onClick={this.handleMenuNavigation}
                  >
                    <ListItemIcon>
                      <ManageAccountsOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Mon compte" />
                  </MenuItem>
                  <MenuItem
                    className="dropdown-item"
                    component={NavLink}
                    to="/orders"
                    selected={this.isCurrentPath('/orders')}
                    onClick={this.handleMenuNavigation}
                  >
                    <ListItemIcon>
                      <ShoppingBagOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Mes commandes" />
                  </MenuItem>
                  <MenuItem
                    className="dropdown-item"
                    component={NavLink}
                    to="/payment"
                    selected={this.isCurrentPath('/payment')}
                    onClick={this.handleMenuNavigation}
                  >
                    <ListItemIcon>
                      <ShoppingCartOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Mon panier" />
                  </MenuItem>
                  <MenuItem
                    className="dropdown-item"
                    component={NavLink}
                    to="/tutorial-delivery"
                    selected={this.isCurrentPath('/tutorial-delivery')}
                    onClick={this.handleMenuNavigation}
                  >
                    <ListItemIcon>
                      <SchoolOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Tutoriel déballage" />
                  </MenuItem>
                  <MenuItem
                    className="dropdown-item"
                    component={NavLink}
                    to="/contact"
                    selected={this.isCurrentPath('/contact')}
                    onClick={this.handleMenuNavigation}
                  >
                    <ListItemIcon>
                      <ContactMailOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Contact" />
                  </MenuItem>

                  <Divider />

                  <MenuItem className="dropdown-item" onClick={this.logout}>
                    <ListItemIcon>
                      <LogoutOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Se déconnecter" />
                  </MenuItem>

                  <div className="dropdown-item tutorial-dropdown-item">
                    <TutorialButton />
                  </div>
                </Menu>
              </div>
            ) : (
              <ul className="header-right">
                <li><NavLink to="/contact">Contact</NavLink></li>
                <li><NavLink to="/new-account">Créer un compte</NavLink></li>
              </ul>
            )}
          </div>
        </div>
        <Login openModal={this.state.openModal} setOpenModal={this.setOpenModal} setToken={this.props.setToken} />

        {/* Remplacer la partie du menu mobile par */}
        <nav className="mobile-bottom-nav">
          {this.props.token ? (
            <>
              <NavLink to="/products" className="nav-item">
                <i className="fas fa-store"></i>
                <span>Produits</span>
              </NavLink>
              <NavLink to="/my-account" className="nav-item">
                <i className="fas fa-user"></i>
                <span>Compte</span>
              </NavLink>
              <NavLink to="/" className="nav-logo">
                <img src={logo} alt="logo dia fleur" />
              </NavLink>
              <NavLink to="/orders" className="nav-item">
                <i className="fas fa-shopping-bag"></i>
                <span>Commandes</span>
              </NavLink>
              <a href="#" onClick={this.logout} className="nav-item">
                <i className="fas fa-sign-out-alt"></i>
                <span>Déconnexion</span>
              </a>
            </>
          ) : (
            <>
              <div className="nav-item nav-item-hidden"></div>
              <div className="nav-item nav-item-hidden"></div>
              <NavLink to="/" className="nav-logo">
                <img src={logo} alt="logo dia fleur" />
              </NavLink>
              <div className="nav-item nav-item-hidden"></div>
              <a href="#" onClick={this.onClickConnect} className="nav-item">
                <i className="fas fa-sign-in-alt"></i>
                <span>Se Connecter</span>
              </a>
            </>
          )}
        </nav>
      </header>
    );
  }
}

export { Header };
